import React, { useEffect } from "react";
import { useState } from "react";
import "../Blog-Details_V1/BlogDetails-1.css";
import ContactQuadImg from "../../../Assets/Images/Mask group.png";
import BlogImg4 from "../../../Assets/Images/BlogPosts-Page/blog-4.jpeg";
import { Icon } from "@iconify/react";

const BlogDetailsFourth = () => {
  const [selectedMap, setSelectedMap] = useState("london");
  const [contactType, setContactType] = useState("business");
  const [hireType, setHireType] = useState("solo");
  const [selectedRoles, setSelectedRoles] = useState([]);

  const mapSources = {
    london:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2482.937598780276!2d-0.05308302443089886!3d51.514360810196145!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4876032b26254b7b%3A0x2fa12815f5510214!2zQnJheWZvcmQgU3EsIFN0ZXBuZXkgR3JlZW4sIExvbmRvbiwg4Kav4KeB4KaV4KeN4Kak4Kaw4Ka-4Kac4KeN4Kav!5e0!3m2!1sbn!2sbd!4v1760679687194!5m2!1sbn!2sbd",
    dhaka:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3651.516185531282!2d90.42534177397057!3d23.76462638823263!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3755c71aaeb538a7%3A0x94846b3432055426!2z4KaV4KeL4Kav4Ka84Ka-4KahIOCmpeCmv-Cmk-CmsOCmvyDgpo_gprLgpp_gpr_gpqHgpr8u!5e0!3m2!1sbn!2sbd!4v1760679807149!5m2!1sbn!2sbd",
  };
  const developerRoles = [
    "JavaScript Developer",
    "Front-End Developer",
    "Dot Net Developer",
    "React Native Developer",
    "Node JS Developer",
    "Blazor Expert",
    "Android Developer",
    "Azure Expert",
    "SQL Developer",
  ];

  const handleRoleChange = (role) => {
    if (selectedRoles.includes(role)) {
      setSelectedRoles(selectedRoles.filter((r) => r !== role));
    } else {
      setSelectedRoles([...selectedRoles, role]);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Message Submitted!!");
    e.target.reset();
  };
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div id="blogs" className="blog-details-3-section">
      {/* Hero Banner */}
      <div className="hero-banner-section">
        <div className="banner-overlay"></div>
        <div className="hero-container container">
          <div className="row">
            <div className="col-lg-12">
              <h6 className="mobile-view">
                <span className="customised-text">Software Development</span>
                <span className="straight-line"></span>
                June 1, 2025
              </h6>

              <h1 className="banner-headline">
                The Importance of Proper Requirements Analysis in Software
                Projects{" "}
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}

      <div className="container">
        <div className="content-section main-contents-card">
          <img
            className="content-img-4 content-img img-fluid"
            src={BlogImg4}
            alt="blog-post-img"
          />

          <div className="cards-contents">
            <h1 className="cards-title">
              The Importance of Proper Requirements Analysis in Software
              Projects
            </h1>
            <p className="cards-text">
              Over the past few years, I’ve had the opportunity to work with
              various companies and clients from around the world. It's been a
              great experience, but also an eye-opener.A common pattern I’ve
              seen is that many clients have worked with other developers or
              companies before coming to me. The most frequent issue? A lack of
              proper requirement analysis at the start of the project. Often,
              projects begin based on verbal agreements or vague requests like:{" "}
              <br></br>
              <span>
                “𝐼 𝑛𝑒𝑒𝑑 𝑠𝑜𝑚𝑒𝑡ℎ𝑖𝑛𝑔 𝑙𝑖𝑘𝑒 𝑎𝑛 𝐸𝑅𝑃 𝑠𝑦𝑠𝑡𝑒𝑚. 𝐶𝑎𝑛 𝑦𝑜𝑢 𝑏𝑢𝑖𝑙𝑑 𝑖𝑡 𝑖𝑛 4–5
                𝑚𝑜𝑛𝑡ℎ𝑠? 𝑀𝑦 𝑏𝑢𝑑𝑔𝑒𝑡 𝑖𝑠 𝑋𝑌𝑍.”
              </span>
              <br></br>
              Honestly, this isn’t the client’s fault. If they had all the
              answers, they wouldn’t need to hire a developer in the first
              place. But this is where trouble begins. At first, everything goes
              smoothly, what we often call the 𝐇𝐨𝐧𝐞𝐲𝐦𝐨𝐨𝐧 𝐏𝐡𝐚𝐬𝐞. But when that
              fades, issues start surfacing. Why? Because there’s no written
              requirement document. Without it, clients don’t know what to
              expect after a few weeks or months. When a milestone is delivered
              and payment requested, there’s often a misalignment between
              expectations and what’s delivered, especially around business
              logic and UI/UX. Clients feel they’re not getting what they asked
              for. Developers feel they delivered what was discussed. Then come
              revision requests, partial payments, delays, frustration, and
              sometimes, project failure.
            </p>

            <h1 className="cards-title">Why does this happen so often?</h1>
            <p className="cards-text">
              Many small or mid-sized businesses take chances on newer companies
              or developers who are eager to prove themselves. These companies
              or developers often say “𝐲𝐞𝐬” to everything without scoping the
              work, just to win the project. This leads to scope creep,
              mismatched expectations, and communication breakdowns.
            </p>

            <h1 className="cards-title">
              My Solution: Understanding Comes First
            </h1>
            <p className="cards-text">
              Before I write a single line of code, I focus on understanding the
              problem. Whether it’s a simple site or a complex system, every
              project starts with clear requirement analysis:
            </p>
            <ul className="blog-lists">
              <li>
                A structured 𝐑𝐞𝐪𝐮𝐢𝐫𝐞𝐦𝐞𝐧𝐭 𝐃𝐨𝐜𝐮𝐦𝐞𝐧𝐭 (𝐒𝐑𝐒) outlining features,
                roles, and workflows
              </li>

              <li>𝐖𝐢𝐫𝐞𝐟𝐫𝐚𝐦𝐞𝐬 𝐨𝐫 𝐦𝐨𝐜𝐤𝐮𝐩𝐬, if needed, to align expectations</li>

              <li>A defined 𝐬𝐜𝐨𝐩𝐞 𝐨𝐟 𝐰𝐨𝐫𝐤, broken into milestones</li>

              <li>Transparent discussion about 𝐢𝐧-𝐬𝐜𝐨𝐩𝐞 𝐯𝐬. 𝐨𝐮𝐭-𝐨𝐟-𝐬𝐜𝐨𝐩𝐞</li>

              <li>
                Alignment on 𝐛𝐮𝐬𝐢𝐧𝐞𝐬𝐬 𝐥𝐨𝐠𝐢𝐜 𝐚𝐧𝐝 𝐩𝐫𝐢𝐨𝐫𝐢𝐭𝐢𝐞𝐬, documented clearly
              </li>
            </ul>

            <h1 className="cards-title">Conclusion</h1>
            <p className="cards-text ">
              This builds trust, reduces friction, and ensures both sides are
              aligned. It helps clients get what they need, and developers
              deliver with clarity. That’s the foundation of every successful
              project I’ve delivered.
            </p>
          </div>
        </div>
      </div>

      {/* Form Section */}
      <div className="footer-business-container">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h1 className="form-title text-center">
                Ready to start your own Business?
              </h1>
              <p className="form-text text-center">
                Contact our team to learn more about how we can help you build
                your next big idea.
              </p>
            </div>

            <div className="col-lg-6 left-col">
              <div className="left-side">
                <div className="label">E-mail Us</div>
                <a
                  className="contact-link gap-3"
                  href="mailto:info@quadtheoryltd.com"
                >
                  <Icon
                    className="contact-link-icon"
                    icon="ph:envelope-simple"
                    width="32"
                  />
                  INFO@QUADTHEORYLTD.COM
                </a>

                <div className="label">Call Us</div>
                <a className="contact-link gap-2" href="tel:+8801776013574">
                  <Icon
                    className="contact-link-icon"
                    icon="lets-icons:phone-light"
                    width="32"
                  />
                  +8801776013574
                </a>

                <div className="dividers"></div>

                <div className="label small-space">Our Offices</div>
                <div className="office-lists">
                  {["london", "dhaka"].map((city) => (
                    <p
                      key={city}
                      className={selectedMap === city ? "active" : ""}
                      onClick={() => setSelectedMap(city)}
                    >
                      <Icon
                        className="map-link-icons"
                        icon="ph:map-pin-light"
                        width="32"
                      />
                      {city === "london"
                        ? "Brayford Square, London, United Kingdom"
                        : "Banasree-B; Road-1; House-21; Dhaka-1219, Bangladesh"}
                    </p>
                  ))}
                </div>

                <div className="map-wrap">
                  <iframe
                    key={selectedMap}
                    src={mapSources[selectedMap]}
                    allowFullScreen=""
                    loading="lazy"
                    title={`${selectedMap} map`}
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-6 form-col">
              <div className="form-panel">
                <div className="toggle-group">
                  {[
                    { value: "business", label: "For your Business" },
                    { value: "hire", label: "For Hire Developers/Team" },
                  ].map((option) => (
                    <label className="radio-pills" key={option.value}>
                      <input
                        type="radio"
                        name="contactType"
                        value={option.value}
                        checked={contactType === option.value}
                        onChange={() => setContactType(option.value)}
                      />
                      <span className="for-hire">{option.label}</span>
                    </label>
                  ))}
                </div>

                <form id="contactForm" onSubmit={handleSubmit}>
                  {[
                    {
                      id: "fullName",
                      type: "text",
                      label: "Full Name",
                      placeholder: "Enter your name",
                    },
                    {
                      id: "email",
                      type: "email",
                      label: "Email",
                      placeholder: "Enter your email",
                    },
                    {
                      id: "mobile",
                      type: "number",
                      label: "Mobile No.",
                      placeholder: "Enter your phone number",
                    },
                  ].map((field) => (
                    <div className="mb-3" key={field.id}>
                      <label htmlFor={field.id}>{field.label}</label>
                      <input
                        type={field.type}
                        id={field.id}
                        className="form-control"
                        placeholder={field.placeholder}
                        required
                      />
                    </div>
                  ))}

                  {contactType === "business" && (
                    <>
                      <div className="mb-3">
                        <label htmlFor="subject">Subject</label>
                        <input
                          type="text"
                          id="subject"
                          className="form-control"
                          placeholder="Enter your title"
                          required
                        />
                      </div>
                      <div className="mb-3">
                        <label htmlFor="message">Description</label>
                        <textarea
                          id="message"
                          rows={7}
                          className="form-control"
                          placeholder="Write down your message(if any)"
                        ></textarea>
                      </div>
                    </>
                  )}

                  {contactType === "hire" && (
                    <>
                      <div className="toggles-contacts gap-3">
                        {["solo", "team"].map((type) => (
                          <label className="hire-option" key={type}>
                            <div className="d-flex">
                              <input
                                type="radio"
                                name="hireType"
                                value={type}
                                checked={hireType === type}
                                onChange={() => setHireType(type)}
                              />
                              <span className="hire-option-label">
                                {type === "solo"
                                  ? "Hire Solo Developer"
                                  : "Development Team"}
                              </span>
                            </div>
                            {hireType === "solo" && type === "solo" && (
                              <div className="developer-list">
                                {developerRoles.map((role) => (
                                  <label key={role} className="developer-role">
                                    <input
                                      type="checkbox"
                                      checked={selectedRoles.includes(role)}
                                      onChange={() => handleRoleChange(role)}
                                    />
                                    {role}
                                  </label>
                                ))}
                              </div>
                            )}
                          </label>
                        ))}
                      </div>

                      <div className="mb-3 mt-4">
                        <label htmlFor="hireMessage">Description</label>
                        <textarea
                          id="hireMessage"
                          rows={7}
                          className="form-control"
                          placeholder="Describe your requirements"
                        ></textarea>
                      </div>
                    </>
                  )}

                  <h1 className="small-text">A note for extra info</h1>
                  <div className="text-start mt-4">
                    <button
                      type="submit"
                      className="send-btn d-flex align-items-center justify-content-center"
                    >
                      SEND {contactType === "business" ? "MESSAGE" : "REQUEST"}
                      <Icon
                        className="send-btn-message-icon"
                        icon="iconoir:nav-arrow-right"
                      />
                    </button>
                  </div>
                </form>
              </div>

              <div className="bg-image mobile-position">
                <img src={ContactQuadImg} alt="Decorative background" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetailsFourth;
